export type Json = Record<string, unknown>

const ZONED_INSTANT =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:\d{2})$/

export const isObject = (v: unknown): v is Json =>
  typeof v === "object" && v !== null && !Array.isArray(v)
export const isNullable = <T>(
  v: unknown,
  is: (v: unknown) => v is T,
): v is T | null => v === null || is(v)
export const isInstant = (v: unknown): v is string =>
  typeof v === "string" && ZONED_INSTANT.test(v) && !Number.isNaN(Date.parse(v))
export const isText = (v: unknown): v is string => typeof v === "string"
export const isMinutes = (v: unknown): v is number =>
  Number.isInteger(v) && (v as number) >= 0
